import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";

import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
function ApprovalSettings() {
  const [programGridData, setProgramGridData] = useState([]);
  const [programData, setProgramData] = useState({}) as any;

  const [showAnimation, setShowAnimation] = useState(false);

  //MM:: Approval related data
  const [requiredApproval, setRequiredApproval] = useState([]) as any;
  const [requiredApprovalFKs, setRequiredApprovalFKs] = useState([]) as any;
  const [requiredApprovalUser, setRequiredApprovalUser] = useState([]) as any;

  const [requiredApprovalData, setRequiredApprovalData] = useState({}) as any;
  const [requiredApprovalUserData, setRequiredApprovalUserData] = useState(
    {}
  ) as any;
  const [requiredApprovalUserModal, setRequiredApprovalUserModal] =
    useState(false);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = programData.IBBProgramID;

    setProgramData((prevState: any) => ({
      ...prevState,
      IBBProgramID: IBBProgramID,
    }));

    IBBProgramGetCompleteGridDataCustom();
  }, []);

  useEffect(() => {}, []);

  useEffect(() => {
    if (programData.IBBProgramID > 0){
    IBBRequiredApprovalGetCompleteDataSetForForeignKeysCustom(
        programData.IBBProgramID
      );
      IBBRequiredApprovalGetCompleteGridDataCustom(programData.IBBProgramID);
    }
  }, [programData.IBBProgramID]);

  function IBBProgramGetCompleteGridDataCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 100;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[1].length > 0) {
            setProgramData((prevState: any) => ({
              ...prevState,
              IBBProgramID: result[1][0].IBBProgramID,
            }));
            setProgramGridData(result[1]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBRequiredApprovalGetCompleteDataSetForForeignKeysCustom(
    IBBProgramID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = programData.IBBProgramID;

    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = IBBProgramID;
    object.isdeleted = false;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBRequiredApproval/IBBRequiredApprovalGetCompleteDataSetForForeignKeysCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setRequiredApprovalFKs(result);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBRequiredApprovalGetCompleteGridDataCustom(IBBProgramID: number) {
    if (IBBProgramID == 0) IBBProgramID = programData.IBBProgramID;

    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = IBBProgramID;
    object.isdeleted = false;
    object.recordsperpage = 1000;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBRequiredApproval/IBBRequiredApprovalGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setRequiredApproval(result[1]);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBRequiredApprovalSaveCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbrequiredapprovalid = requiredApprovalData.IBBRequiredApprovalID;
    object.ibbprogramid = programData.IBBProgramID;
    object.ibbprogramstageid = requiredApprovalData.IBBProgramStageID;
    object.ibbscorecardid = requiredApprovalData.IBBScorecardID;
    object.ibbdepartmentid = requiredApprovalData.IBBDepartmentID;
    object.ibbprogramsectionid = requiredApprovalData.IBBProgramSectionID;
    object.name = requiredApprovalData.Name;
    object.description = requiredApprovalData.Description;
    object.issignaturerequired = requiredApprovalData.IsSignatureRequired;
    object.isdeleted = requiredApprovalData.IsDeleted;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBRequiredApproval/IBBRequiredApprovalSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setRequiredApprovalData({ IsAddEditMode: false, IBBScorecardID: 0 });
          IBBRequiredApprovalGetCompleteGridDataCustom(0);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBRequiredApprovalDeleteRecordCustom(
    IBBRequiredApprovalID: number
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbrequiredapprovalid = IBBRequiredApprovalID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBRequiredApproval/IBBRequiredApprovalDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBRequiredApprovalGetCompleteGridDataCustom(0);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}

      <div className="flex-container">
        <div style={{ width: "33.33%" }}>
          <select
            className="select-md"
            value={programData.IBBProgramID}
            onChange={(e) =>
              setProgramData((prevState: any) => ({
                ...prevState,
                IBBProgramID: Number(e.target.value),
              }))
            }
          >
            {programGridData &&
              programGridData.map((Item: any, index: any) => (
                <option
                  value={Item.IBBProgramID}
                  key={"program" + Item.IBBProgramID}
                >
                  {Item.Name}
                </option>
              ))}
          </select>
        </div>
      </div>

      <div className="page--contents">
        <div className="page--data">
          {programData.IBBProgramID > 0 && (
            <>
             <div className="pg-importers-table">
                  <div className="flex-container">
                    <span className="pg-title">Approval Settings</span>
                    <div className="ed-list">
                      <a
                        title="Add Approval"
                        onClick={() => {
                          setRequiredApprovalData({
                            IsAddEditMode: true,
                            IBBScorecardID: 0,
                            IsSignatureRequired: false,
                          });
                        }}
                      >
                        <img
                          src="images/add-black.svg"
                          width={15}
                          height={15}
                        />
                      </a>
                    </div>
                  </div>
                  {!requiredApprovalData.IsAddEditMode &&
                    requiredApproval &&
                    requiredApproval.length > 0 && (
                      <div className="section-table">
                        <table
                          className="part-head trend-table fixed-table"
                          id="tblData"
                        >
                          <thead>
                            <tr>
                              <th>Stage</th>
                              <th>Functional Area</th>
                              {/* <th>Actual Signature Required</th> */}
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {requiredApproval.map((item: any, index: any) => (
                              <React.Fragment
                                key={"requiredapprovalgrid" + index}
                              >
                                <tr>
                                  <td>
                                    {/* <div className="flex-open flex-l1">
                                      {item.showUserData ? (
                                        <a
                                          onClick={() => {
                                            let requiredApprovalLocal = [
                                              ...requiredApproval,
                                            ];
                                            requiredApprovalLocal[
                                              index
                                            ].showUserData = false;
                                            setRequiredApproval(
                                              requiredApprovalLocal
                                            );
                                          }}
                                        >
                                          -
                                        </a>
                                      ) : (
                                        <a
                                          onClick={() => {
                                            let requiredApprovalLocal = [
                                              ...requiredApproval,
                                            ];
                                            requiredApprovalLocal[
                                              index
                                            ].showUserData = true;
                                            setRequiredApproval(
                                              requiredApprovalLocal
                                            );
                                          }}
                                        >
                                          +
                                        </a>
                                      )}
                                    </div> */}

                                    {item.IBBProgramStageName}
                                  </td>
                                  <td>{item.IBBDepartmentName}</td>
                                  {/* <td>
                                    {item.IsSignatureRequired ? (
                                      <span>Yes</span>
                                    ) : (
                                      <span>No</span>
                                    )}
                                  </td> */}
                                  <td>
                                    <div className="ed-list">
                                      <a
                                        onClick={() => {
                                          let itemLocal = item;
                                          itemLocal.IsAddEditMode = true;
                                          setRequiredApprovalData(itemLocal);
                                        }}
                                      >
                                        <img
                                          src="images/edit.svg"
                                          width={15}
                                          height={15}
                                        />
                                      </a>
                                      <a
                                        onClick={() => {
                                          IBBRequiredApprovalDeleteRecordCustom(
                                            item.IBBRequiredApprovalID
                                          );
                                        }}
                                      >
                                        <img
                                          src="images/delete.svg"
                                          width={15}
                                          height={15}
                                        />
                                      </a>                                      
                                    </div>
                                  </td>
                                </tr>

                                {item.showUserData &&
                                  requiredApprovalUser &&
                                  requiredApprovalUser.map(
                                    (itemUser: any, indexUser: any) => (
                                      <React.Fragment
                                        key={
                                          "requiredapprovalgriduser" + indexUser
                                        }
                                      ></React.Fragment>
                                    )
                                  )}
                              </React.Fragment>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                  {requiredApprovalData.IsAddEditMode && (
                    <div>
                      {/* {requiredApprovalData.IBBRequiredApprovalID > 0 ? (
                        <span>Edit Approval</span>
                      ) : (
                        <span>Add Approval</span>
                      )} */}

                      <span>Stage: </span>
                      <select
                        className="select-md"
                        value={requiredApprovalData.IBBProgramStageID}
                        onChange={(e) =>
                          setRequiredApprovalData((prevState: any) => ({
                            ...prevState,
                            IBBProgramStageID: Number(e.target.value),
                          }))
                        }
                      >
                        <option value="0" key={"stage0"}>
                          Please Select
                        </option>
                        {requiredApprovalFKs &&
                          requiredApprovalFKs[1] &&
                          requiredApprovalFKs[1].map(
                            (Item: any, index: any) => (
                              <option value={Item.PID} key={"stage" + Item.PID}>
                                {Item.Name}
                              </option>
                            )
                          )}
                      </select>

                      <span>Functional Area: </span>
                      <select
                        className="select-md"
                        value={requiredApprovalData.IBBDepartmentID}
                        onChange={(e) =>
                          setRequiredApprovalData((prevState: any) => ({
                            ...prevState,
                            IBBDepartmentID: Number(e.target.value),
                          }))
                        }
                      >
                        <option value="0" key={"stage0"}>
                          Please Select
                        </option>
                        {requiredApprovalFKs &&
                          requiredApprovalFKs[3] &&
                          requiredApprovalFKs[3].map(
                            (Item: any, index: any) => (
                              <option value={Item.PID} key={"stage" + Item.PID}>
                                {Item.Name}
                              </option>
                            )
                          )}
                      </select>

                      {/* <span>Section: </span>
                      <select
                        className="select-md"
                        value={requiredApprovalData.IBBProgramSectionID}
                        onChange={(e) =>
                          setRequiredApprovalData((prevState: any) => ({
                            ...prevState,
                            IBBProgramSectionID: Number(e.target.value),
                          }))
                        }
                      >
                        <option value="0" key={"section0"}>
                          Please Select
                        </option>
                        {requiredApprovalFKs &&
                          requiredApprovalFKs[4] &&
                          requiredApprovalFKs[4].map(
                            (Item: any, index: any) => (
                              <option
                                value={Item.PID}
                                key={"section" + Item.PID}
                              >
                                {Item.Name}
                              </option>
                            )
                          )}
                      </select> */}

                      {/* <p>Is Signature Required:</p>
                      <input
                        type="checkbox"
                        className="input-check"
                        checked={requiredApprovalData.IsSignatureRequired}
                        onChange={(e) =>
                          setRequiredApprovalData((prevState: any) => ({
                            ...prevState,
                            IsSignatureRequired:
                              !requiredApprovalData.IsSignatureRequired,
                          }))
                        }
                      /> */}

                      <div className="form-btns">
                        <a onClick={() => IBBRequiredApprovalSaveCustom()}>
                          Save
                        </a>
                        <a
                          onClick={() => {
                            setRequiredApprovalData({ IsAddEditMode: false });
                          }}
                        >
                          Cancel
                        </a>
                      </div>
                    </div>
                  )}
                </div>
            </>
          )}

        </div>
      </div>      
    </>
  );
}

export default ApprovalSettings;
